import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  FeeItem,
  FeeLog,
  TariffLogTypeEnum,
  WriteOffFeeCurrency,
  WriteOffType,
} from '../../../tariff/types';
import { OrganizationType, FeeTypeItem } from '../../../types';

export interface Fee {
  name?: string;
  type?: string;
  writeOffType?: WriteOffType;
  writeOffValue?: string;
  minAmountAllowed?: string;
  maxAmountAllowed?: string;
  currency?: string;
  currencyForWritingOffFee?: WriteOffFeeCurrency;
  feeAccountNumber?: string;
  logs?: FeeLog[];
}

export interface CustomerFeeForm {
  requestInProgress: boolean;
  formValues: Fee;
  customerId?: string;
  customerType?: OrganizationType;
  onSubmitSuccess?: boolean;
  feeTypes?: FeeTypeItem[];
  searchQuery: string;
  fee?: {
    values?: FeeItem;
    logs?: FeeLog[];
  };
  feeId?: string;
  isLoading: boolean;
}

const initialState: CustomerFeeForm = {
  requestInProgress: false,
  onSubmitSuccess: false,
  formValues: {},
  searchQuery: '',
  isLoading: false,
};

export const customerFeeFormSlice = createSlice({
  name: 'customerFeeForm',
  initialState,
  reducers: {
    onFeeTypesSearch: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    onSubmitFee: (
      state,
      action: PayloadAction<{
        customerId: string;
        customerType: OrganizationType;
        formValues: Fee;
      }>,
    ) => {
      state.requestInProgress = true;
      state.customerId = action.payload.customerId;
      state.customerType = action.payload.customerType;
      state.formValues = action.payload.formValues;
    },
    onSubmitFeeSuccess: (state) => {
      state.requestInProgress = false;
      state.onSubmitSuccess = true;
    },
    getFee: (state, action: PayloadAction<FeeItem>) => {
      state.isLoading = true;
      state.fee = {
        values: action.payload,
        logs: [
          {
            id: 'l-uuid-1',
            type: TariffLogTypeEnum.CHANGED_WRITE_OFF_TYPE,
            from: 'Fixed value',
            to: 'Percent of balance',
            user: {
              firstName: 'Christian',
              lastName: 'Evans',
            },
            date: new Date().toISOString(),
            isModified: true,
          },
          {
            id: 'l-uuid-2',
            type: TariffLogTypeEnum.SET_WRITE_OFF_VALUE,
            value: '1.5%',
            user: {
              firstName: 'Christian',
              lastName: 'Evans',
            },
            date: new Date().toISOString(),
          },
        ],
      };
    },
    clearFeeFormState: (state) => {
      state.requestInProgress = false;
      state.onSubmitSuccess = false;
      state.customerId = undefined;
      state.customerType = undefined;
      state.fee = undefined;
      state.feeId = undefined;
      state.isLoading = false;
      state.searchQuery = '';
      state.formValues = {};
    },
  },
});

export const {
  onSubmitFee,
  onSubmitFeeSuccess,
  clearFeeFormState,
  onFeeTypesSearch,
  getFee,
} = customerFeeFormSlice.actions;

export default customerFeeFormSlice.reducer;
